export default "__VITE_ASSET__Bc$pm2Ah__"